export const SelectionHeaderCell = () => {
  return (
    <div className="h-full text-xs font-normal pl-2 flex items-center gap-2">
      <div className="flex-1 font-bold flex items-center gap-1"></div>
      <div className="h-6 w-[1px] bg-gray-2 group-[.is-last-column]:hidden"></div>
    </div>
  );
};
